import { useNotifications } from "@web/features/Notification/useNotifications";

useNotifications(); // Does nothing, it just gets imported so the code "runs"
